module.exports = __webpack_public_path__ + "72d6fb9248832490a8f4ab459510b58a.jpg";